// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__4eCRm","actions":"GroupTable_actions__U2X3N","deleteModalFooter":"GroupTable_deleteModalFooter__1s7gk"};